import { Table, Badge, Text, Paper, ScrollArea } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import type { Persona } from '../types';

interface PersonaTableProps {
  personas: Persona[];
}

export function PersonaTable({ personas }: PersonaTableProps) {
  const navigate = useNavigate();

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'active':
        return 'green';
      case 'inactive':
        return 'gray';
      default:
        return 'blue';
    }
  };

  const getTypeColor = (type: string | null) => {
    switch (type) {
      case 'person':
        return 'blue';
      case 'vehicle':
        return 'orange';
      default:
        return 'gray';
    }
  };

  const getTypeLabel = (type: string | null) => {
    switch (type) {
      case 'person':
        return 'Person';
      case 'vehicle':
        return 'Vehicle';
      default:
        return 'Unknown';
    }
  };

  const rows = personas.map((persona) => (
    <Table.Tr
      key={persona.persona_id}
      onClick={() => navigate(`/personas/${persona.persona_id}`)}
      style={{ cursor: 'pointer' }}
    >
      <Table.Td>
        <Badge color={getTypeColor(persona.persona_type)} variant="light">
          {getTypeLabel(persona.persona_type)}
        </Badge>
      </Table.Td>
      <Table.Td>
        <Text size="sm">{format(new Date(persona.last_seen), 'MMM d, yyyy HH:mm')}</Text>
      </Table.Td>
      <Table.Td>
        <Badge color={getStatusColor(persona.status)} variant="filled">
          {persona.status}
        </Badge>
      </Table.Td>
      <Table.Td>
        <Text size="sm">{persona.observation_count}</Text>
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <Paper withBorder>
      <ScrollArea>
        <Table striped highlightOnHover>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Type</Table.Th>
              <Table.Th>Last Seen</Table.Th>
              <Table.Th>Status</Table.Th>
              <Table.Th>Observations</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>{rows}</Table.Tbody>
        </Table>
      </ScrollArea>
    </Paper>
  );
}
